var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDone02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 109,
    viewBox: "0 0 109 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 54.5013,
    cy: 54.5003,
    r: 50.14,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.5 0C24.4644 0 0 24.3433 0 54.5C0 84.5356 24.4644 109 54.5 109C84.5356 109 109 84.5356 109 54.5C109 24.3433 84.5356 0 54.5 0ZM81.9922 40.2089L47.4756 74.7256C46.9915 75.2096 46.3858 75.4521 45.78 75.4521C45.1743 75.4521 44.5686 75.2096 44.0845 74.7256L27.1294 57.7704C26.1604 56.8014 26.1604 55.3484 27.1294 54.3793C28.0984 53.4103 29.5514 53.4103 30.5205 54.3793L45.7803 69.6391L78.6014 36.818C79.5704 35.849 81.0234 35.849 81.9925 36.818C82.9615 37.6662 82.9615 39.2409 81.9925 40.21L81.9922 40.2089Z",
    fill: "#009B93"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDone02);
export default __webpack_public_path__ + "static/media/done02.65ad366c22922e9d6f53e7fcd70327c1.svg";
export { ForwardRef as ReactComponent };